import type { Dispatch, SetStateAction } from 'react'

import type { Progress } from '@/modules/upload'

export const updateFileCollection = <T>(
  value: T,
  i: number,
  setter: Dispatch<SetStateAction<T[]>>,
): void =>
  setter((prev) => {
    prev[i] = value
    return [...prev]
  })

export const sumProgress = (
  progress: Progress[],
): Pick<Progress, 'loaded' | 'total'> =>
  progress.reduce(
    (result, current) => {
      if (!current) return result

      return {
        loaded: current.loaded + result.loaded,
        total: current.total + result.total,
      }
    },
    { loaded: 0, total: 0 },
  )

export const buildProgress = ({
  loaded,
  total,
}: Pick<Progress, 'loaded' | 'total'>): Progress => ({
  loaded,
  total,
  percent: total ? (loaded / total) * 100 : 0,
})
